import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const InfoFilledSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "3 3 26 26",
  color = "#236998",
  ...rest
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 29C23.1797 29 29 23.1797 29 16C29 8.8203 23.1797 3 16 3C8.8203 3 3 8.8203 3 16C3 23.1797 8.8203 29 16 29ZM15.901 11.2705C16.7836 11.2705 17.4829 10.575 17.4829 9.69199C17.4829 8.80893 16.7836 8.10938 15.901 8.10938C15.0299 8.10938 14.3191 8.80893 14.3191 9.69199C14.3191 10.575 15.0299 11.2705 15.901 11.2705ZM13.6651 23.3374H19.0467C19.5273 23.3374 19.9057 22.9885 19.9057 22.5013C19.9057 22.0426 19.5273 21.6769 19.0467 21.6769H17.2793V14.6145C17.2793 13.9932 16.9589 13.5809 16.3739 13.5809H13.8549C13.3743 13.5809 13.0076 13.9467 13.0076 14.399C13.0076 14.8809 13.3743 15.2351 13.8549 15.2351H15.4326V21.6769H13.6651C13.1793 21.6769 12.8062 22.0426 12.8062 22.5013C12.8062 22.9885 13.1793 23.3374 13.6651 23.3374Z"
        fill={color}
      />
    </svg>
  );
};

export { InfoFilledSvg };
